import { CalendarEventRef, ID, IDPrefixes } from '@griply/types';

import { getCompositeIdParts } from './encoded-ids/composite-id';

export type ExternalCalendarEventRefInput = {
  eventId?: ID;
  connectionId?: ID;
  calendarId?: ID;
};

// The provider only knows the original id, never a multi-day chunk's composite one.
const toProviderEventId = (eventId: ID): ID =>
  getCompositeIdParts(eventId, IDPrefixes.MultiDayEvent)?.[0] ?? eventId;

// One rule for both platforms: an older backend omits the connection/calendar pair, and
// without it the event cannot be resolved back to a calendar. Callers treat null as
// "fall back to the provider url" rather than opening a detail surface that cannot load.
export const getExternalCalendarEventRef = ({
  eventId,
  connectionId,
  calendarId,
}: ExternalCalendarEventRefInput): CalendarEventRef | null => {
  if (!eventId || !connectionId || !calendarId) {
    return null;
  }

  return { eventId: toProviderEventId(eventId), connectionId, calendarId };
};
